import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fatura görünüm ayarı (ürün kodu göster/gizle · iskonto gösterimi) — TEK ortak ayar: bir ekranda değişince
// tüm açık ekranlara (önizleme, detay, QNB kesim) anında yansır ve sunucuda saklanır.
const DEFAULT = { include_codes: false, discount_display: "net" };
let state = { ...DEFAULT };
let loaded = false;
let loading = null;
const subs = new Set();
const emit = () => subs.forEach((fn) => fn(state));

export const loadInvoiceView = () => {
  if (loaded) return Promise.resolve(state);
  if (!loading) {
    loading = api.get("/settings/invoice-view").then((r) => { state = { ...DEFAULT, ...(r.data || {}) }; loaded = true; emit(); return state; })
      .catch(() => state).finally(() => { loading = null; });
  }
  return loading;
};

export const saveInvoiceView = async (patch) => {
  const next = { ...state, ...patch };
  state = next; emit();
  try { await api.put("/settings/invoice-view", next); } catch { /* sunucu hatası → yerel değer kalır */ }
  return next;
};

export function useInvoiceView() {
  const [v, setV] = useState(state);
  useEffect(() => {
    subs.add(setV);
    loadInvoiceView();
    return () => { subs.delete(setV); };
  }, []);
  return [v, saveInvoiceView];
}
